import Headline from "../ui/Headline"
import Text from "../ui/Text"

type Props = {
    headline: string
    subline?: string
    text?: string
    bulletsTitle?: string
    bullets?: string[]
    image?: string
    ctaLabel?: string
    ctaHref?: string
}
const ComponentRenderer: React.FC<Props> = ({ headline, subline, text, bulletsTitle, bullets, image, ctaLabel, ctaHref }) => {
    return (
        <div className="flex flex-col">
            <Headline headline={headline} size="xlarge" />
            {!!subline && <Text bold size="xlarge" className="mt-4" text={subline} />}
            {!!text && <Text className="mt-4" text={text} />}
            {bullets && bullets.length > 0 && (
                <div className="mt-6 flex flex-col items-center gap-4 sm:flex-row sm:items-center sm:gap-5">
                    <div className="shrink-0">
                        <img src={image} alt="" className="mx-auto h-auto w-24 max-w-full object-contain object-center sm:mx-5 sm:w-28" />
                    </div>
                    <div className="w-full">
                        <Text bold size="large" className="mb-2" text={bulletsTitle} />
                        <ul className="list-none space-y-1 text-sm text-blue md:text-base">
                            {bullets.map((item) => (
                                <li key={item} className="flex gap-2">
                                    <span className="text-blue">–</span>
                                    <Text text={item} />
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
            <a
                href={ctaHref}
                className="mt-8 text-center w-full border border-blue px-3 py-2 text-lg font-bold text-blue no-underline transition-colors hover:bg-blue hover:text-white"
            >
                {ctaLabel}
            </a>
        </div>
    )
}

export default ComponentRenderer